/**
 * App Component - Application Root
 * Following Clean Architecture: Composes providers and router
 */

import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { QueryProvider } from '@/components/providers';
import { useSessionBootstrap } from '@/hooks/useSessionBootstrap';
import { router } from '@/router';
import '@/styles/globals.css';

function App() {
  // On app load, bootstrap the session from /me/profile using the cookie
  useSessionBootstrap();

  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster richColors position="top-right" />
    </QueryProvider>
  );
}

export default App;
